module.exports = "../../app/cells/pages/guides/v2_resources/file-chart-line.erb";